<h1 mat-dialog-title *ngIf="!loading">Unlink the current account?</h1>
<h1 mat-dialog-title *ngIf="!loading">This will remove the link between this record and the associated user account in the database. Are you sure you want to do this?</h1>
<div mat-dialog-actions *ngIf="!loading">
  <button mat-raised-button (click)="closeDialog()" color="primary">Cancel</button>
  <button mat-raised-button (click)="submitDialog()" color="warn">Unlink</button>
</div>
<mat-spinner *ngIf="loading"></mat-spinner>